import { NgModule } from '@angular/core';
import { ZcWidgetCoreComponent } from './zc-widget-core.component';
import { CommonModule } from '@angular/common';
import { ZcWidgetCoreService } from './zc-widget-core.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ZcWidgetCoreComponent],
  exports: [ZcWidgetCoreComponent]
})
export class ZcWidgetCoreModule {
  static forRoot(siteConfig?: any) {
    console.log('siteConfig', siteConfig);
    return {
      ngModule: ZcWidgetCoreModule,
      providers: [ZcWidgetCoreService, { provide: 'config', useValue: siteConfig }]
    }
  };
}
